/*
 * Juriidiliste lehtede sisukord.
 *
 * Sisu tuleb ühe HTML-plokina (policy.body või page.content), seega ankruid ei
 * saa Liquidis tekitada — teeme need siin: iga h2 saab id ja sisukorda rea.
 *
 * Progressiivne: ilma JS-ita jääb .legal-page__toc peitu (CSS-is display:none,
 * .is-ready lisatakse alles siis, kui nimekiri on päriselt täis) ja tekst on
 * täiesti loetav. Seega ei ole see nõue, vaid lisand.
 */
(function () {
  function slugify(text, index) {
    const base = text
      .toLowerCase()
      .trim()
      // Eesti täpitähed: ilma nendeta jääks "Üldtingimused" → "ldtingimused".
      .replace(/[äàáâã]/g, 'a')
      .replace(/[öòóôõ]/g, 'o')
      .replace(/[üùúû]/g, 'u')
      .replace(/[õ]/g, 'o')
      .replace(/[šž]/g, 's')
      .replace(/[èéêë]/g, 'e')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
    return base ? `${base}-${index}` : `osa-${index}`;
  }

  /*
   * Tabelile kerimiskast ümber. Sisu on toimetaja käes (Settings → Policies või
   * lehe tekstiväli), seega võib sinna igal ajal tekkida tabel, mida keegi ei
   * mähi — mähkimata lai tabel venitaks mobiilis kogu lehe horisontaalselt
   * keritavaks.
   */
  function wrapTables(body) {
    body.querySelectorAll('table').forEach((table) => {
      const parent = table.parentElement;
      if (parent && parent.classList.contains('legal-page__table-wrap')) return;

      const wrap = document.createElement('div');
      wrap.className = 'legal-page__table-wrap';
      table.replaceWith(wrap);
      wrap.appendChild(table);
    });
  }

  function build(root) {
    const body = root.querySelector('.legal-page__body');
    const toc = root.querySelector('.legal-page__toc');
    if (!body) return;

    wrapTables(body);

    if (!toc) return;

    const headings = body.querySelectorAll('h2');
    // Alla kolme pealkirja ei ole sisukorda mõtet näidata — lisaks müra.
    if (headings.length < 3) return;

    const list = toc.querySelector('.legal-page__toc-list');
    if (!list) return;

    const links = [];

    headings.forEach((heading, index) => {
      const text = heading.textContent.trim();
      if (!heading.id) heading.id = slugify(text, index + 1);

      const item = document.createElement('li');
      item.className = 'legal-page__toc-item';

      const link = document.createElement('a');
      link.className = 'legal-page__toc-link';
      link.href = `#${heading.id}`;
      link.textContent = text;

      item.appendChild(link);
      list.appendChild(item);
      links.push({ link, heading });
    });

    toc.classList.add('is-ready');

    /*
     * Sisukord on <details>: mobiilis kokku klapitud (muidu lükkab sisu
     * ekraanilt välja), lauaarvutis püsivalt lahti. CSS-iga seda avada ei saa —
     * suletud <details> sisu peidab brauser ise, mitte stiilireegel.
     */
    if (toc.tagName === 'DETAILS' && window.matchMedia) {
      const desktop = window.matchMedia('(min-width: 990px)');
      const sync = (event) => {
        toc.open = event.matches;
      };
      sync(desktop);
      if (desktop.addEventListener) desktop.addEventListener('change', sync);
      else if (desktop.addListener) desktop.addListener(sync);
    }

    // Aktiivse jaotise märkimine. IntersectionObserver puudumisel jääb sisukord
    // tööle, lihtsalt ilma esiletõsteta.
    if (!('IntersectionObserver' in window)) return;

    const seen = new Map();
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => seen.set(entry.target, entry.isIntersecting));

        let active = null;
        for (const { link, heading } of links) {
          if (seen.get(heading)) {
            active = link;
            break;
          }
        }

        links.forEach(({ link }) => {
          if (link === active) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
      },
      // Ülemine riba ekraanist: pealkiri loetakse aktiivseks, kui ta on ülaosas.
      { rootMargin: '-12% 0px -70% 0px' }
    );

    links.forEach(({ heading }) => observer.observe(heading));
  }

  function init() {
    document.querySelectorAll('[data-legal-page]').forEach(build);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
